import React, { useState } from 'react';
import { Tabs, Tab, TabContent } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import HeaderTwo from "../components/header/HeaderTwo";
import FooterTwo from "../components/footer/FooterTwo"; // Correto
import Breadcrumb from "./Breadcrumb";

/* ===========================
   DADOS DO PORTFÓLIO (GB Partner)
=========================== */
const portfolioData = [
  {
    category: 'Crédito',
    key: 'credito',
    route: 'credito-empresarial',
    image: '/assets/images/novos/1/1.png',
    title: 'Crédito Empresarial',
    description: 'Estruturação de operações financeiras sob medida para empresas.'
  },
  {
    category: 'Agro',
    key: 'agro',
    route: 'agro',
    image: '/assets/images/novos/1/2.png',
    title: 'Soluções para o Agro',
    description: 'Soluções financeiras e inteligência estratégica para o agronegócio.'
  },
  {
    category: 'Seguros',
    key: 'seguros',
    route: 'seguros',
    image: '/assets/images/novos/1/3.png',
    title: 'Seguros e Proteção',
    description: 'Proteção patrimonial completa para ativos empresariais e rurais.'
  },
  {
    category: 'Sustentabilidade',
    key: 'carbono',
    route: 'credito-carbono',
    image: '/assets/images/novos/1/4.png',
    title: 'Crédito de Carbono',
    description: 'Estruturação de ativos ambientais e monetização sustentável.'
  },
  {
    category: 'Estratégia',
    key: 'inteligencia',
    route: 'inteligencia-mercado',
    image: '/assets/images/novos/1/5.png',
    title: 'Inteligência de Mercado',
    description: 'Apoio consultivo estratégico para decisões de alto impacto.'
  }
];

/* ===========================
   GRID REUTILIZÁVEL
=========================== */
const PortfolioGrid = ({ items }) => (
  <div className="row g-5">
    {items.map((item, index) => (
      <div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div className="rts-product-one">
          <div className="thumbnail-area">
            {/* Caminho absoluto com / */}
            <img src={item.image} alt={item.title} />
            <Link
              className="rts-btn btn-primary rounded"
              to={`/servicos/${item.route}`}
            >
              <i className="far fa-arrow-right" />
            </Link>
          </div>

          <div className="product-contact-wrapper">
            <span>{item.category}</span>
            <Link to={`/servicos/${item.route}`}>
                <h5 className="title">{item.title}</h5>
            </Link>
            <p className="disc">{item.description}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
);

/* ===========================
   COMPONENTE PRINCIPAL
=========================== */
function Project() {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Nossas Soluções' }
  ];

  const [activeKey, setActiveKey] = useState('all');

  return (
    <div>
      <HeaderTwo />

      <Breadcrumb title="Nossas Soluções" breadcrumbs={breadcrumbs} />

      <div className="rts-project-area rts-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-12">

              {/* TABS ALINHADAS COM OS 5 PILARES */}
              <div className="tab-button-area-one">
                <Tabs
                  activeKey={activeKey}
                  onSelect={(k) => setActiveKey(k)}
                  className="mb-3"
                >
                  <Tab eventKey="all" title="Todas" />
                  <Tab eventKey="credito" title="Crédito" />
                  <Tab eventKey="agro" title="Agro" />
                  <Tab eventKey="seguros" title="Seguros" />
                  <Tab eventKey="carbono" title="Carbono" />
                  <Tab eventKey="inteligencia" title="Inteligência" />
                </Tabs>
              </div>

              <div className="tab-content-area mt--50 mt_sm--30">
                {activeKey === 'all' && (
                  <TabContent>
                    <PortfolioGrid items={portfolioData} />
                  </TabContent>
                )}

                {activeKey !== 'all' && (
                  <TabContent>
                    <PortfolioGrid
                      items={portfolioData.filter(item => item.key === activeKey)}
                    />
                  </TabContent>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>

      <FooterTwo />
    </div>
  );
}

export default Project;